import React from 'react';
import { ContainerNcmEmLote } from './styles';
import FormDefault from '~/components/FormDefault';
import { FormNcmEmLote } from './components/Form';
import { TableNcmEmLote } from './components/Table';
import { TransferirNcm } from './components/TransferirNcm';
import { useAlteracaoNcmLote } from './hooks/useAlteracaoNcmLote';

export const AlteracaoNcmEmLoteContent: React.FC = () => {
  const { onClearFields } = useAlteracaoNcmLote();

  return (
    <ContainerNcmEmLote>
      <FormDefault
        codTela={327}
        title="Alteração de NCM em Lote"
        onSave={() => Promise.resolve()}
        isUpdate={false}
        onCancel={() => []}
        onNew={() => []}
        onDelete={() => []}
        onClearFields={onClearFields}
        onReturnSearch={() => []}
        isSave
        isCancel={false}
        showIconSave={false}
        isBackSearch={false}
        customButtons={<TransferirNcm />}
      >
        <FormNcmEmLote />
        <TableNcmEmLote />
      </FormDefault>
    </ContainerNcmEmLote>
  );
};
